import React from 'react'
import PageContent from 'components/common/PageContent'
import HabitsTable from 'components/habits/HabitsTable'

export default function Habits(props) {

    const pathElements = [
        {id: 0, title: "Home", url: "/"},
        {id: 1, title: "Habits"}
    ];

    return (
        <PageContent pathElements={pathElements} >
            <HabitsTable/>
        </PageContent>
    );
}